import * as React from 'react'
import { ImageIcon } from '../icons/ImageIcon'
import { styled, useTheme } from '../../theme/styled'
import { Typography } from '../Typography'
import ImageUnavailableProps from './ImageUnavailableProps'

const ImageUnavailableContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  background: ${(p) => p.theme.av8.backgroundAlt};
  height: 100%;
  width: 100%;
  color: ${(p) => (p.color ? p.color : p.theme.av8.secondaryColor)};
  letter-spacing: 2px;
`

const Message = styled(Typography)`
  text-transform: uppercase;
  margin-top: 0.5rem;
  text-align: center;
  font-size: ${(p) => p.theme.av8.typography.sizes.mobile.small};
`

export default function ImageUnavailable(props: ImageUnavailableProps) {
  const theme = useTheme()
  const { message = 'Image Unavailable', color = theme.av8.secondaryColor, ...rest } = props
  return (
    <ImageUnavailableContainer {...rest}>
      <ImageIcon color={color} />
      <Message>{message}</Message>
    </ImageUnavailableContainer>
  )
}
